import { fetchCatch } from 'src/core/sentry';
import type { OwnerAddonOptionalAmounts, PaymentAddon } from 'src/types/trips/PaymentAddon';
import { apiFetchThunk } from 'src/common/ducks/fetch';
import { PAYMENT_STATUS } from '../constants';

// Actions
export const SET_PAYMENT_ADDONS = 'inbox/paymentAddons/SET_PAYMENT_ADDONS';
export const SET_OWNER_ADDONS_OPTIONAL_AMOUNTS = 'inbox/paymentAddons/SET_OWNER_ADDONS_OPTIONAL_AMOUNTS';
export const CLEAR_PAYMENT_ADDONS = 'inbox/paymentAddons/CLEAR_PAYMENT_ADDONS';

export type AddonsSlice = {
  paymentAddons: PaymentAddon[];
  ownerOptionalAmounts: OwnerAddonOptionalAmounts[];
};
const initialState: AddonsSlice = {
  paymentAddons: [],
  ownerOptionalAmounts: [],
};
// Reducer
const paymentAddonsReducer = (
  // eslint-disable-next-line @typescript-eslint/default-param-last
  state: AddonsSlice = initialState,
  action: {
    type: 'inbox/paymentAddons/SET_PAYMENT_ADDONS';
    paymentAddons?: PaymentAddon[];
  } | {
    type: 'inbox/paymentAddons/SET_OWNER_ADDONS_OPTIONAL_AMOUNTS';
    ownerOptionalAmounts?: OwnerAddonOptionalAmounts[];
  } | {
    type: 'inbox/paymentAddons/CLEAR_PAYMENT_ADDONS';
  },
) => {
  switch (action.type) {
    case SET_PAYMENT_ADDONS: {
      return {
        ...state,
        paymentAddons: action.paymentAddons,
      };
    }
    case SET_OWNER_ADDONS_OPTIONAL_AMOUNTS:
      return {
        ...state,
        ownerOptionalAmounts: action.ownerOptionalAmounts,
      };
    case CLEAR_PAYMENT_ADDONS:
      return initialState;
    default:
      return state;
  }
};

// Action creators
export const setPaymentAddons = (paymentAddons: PaymentAddon[]) => ({
  type: SET_PAYMENT_ADDONS,
  paymentAddons,
});
export const setOwnerAddonsOptionalAmounts = (
  ownerOptionalAmounts: OwnerAddonOptionalAmounts[],
) => ({
  type: SET_OWNER_ADDONS_OPTIONAL_AMOUNTS,
  ownerOptionalAmounts,
});

export const clearPaymentAddons = () => ({ type: CLEAR_PAYMENT_ADDONS });

export const getPaymentAddonsCall = (tripId: number, isRenter: boolean) => (
  (dispatch: any) => dispatch(apiFetchThunk(`/trips/${tripId}/owner_addons/${isRenter
    ? `for_renter/?status=${PAYMENT_STATUS.PENDING}`
    : ''}`))
    .then((response: Response) => {
      if (!response.ok) {
        fetchCatch(response);
        // eslint-disable-next-line @typescript-eslint/no-throw-literal
        throw response;
      }
      return response.json();
    })
    .then((paymentAddons: PaymentAddon[]) => {
      dispatch(setPaymentAddons(paymentAddons));
      return paymentAddons;
    }));

export const getOwnerAddonsOptionalAmountsCall = (tripId: number) => (
  (dispatch: any) => dispatch(apiFetchThunk(
    `/trips/${tripId}/owner_addons/optional_addons_amounts/`,
  )).then((response: Response) => {
    if (!response.ok) {
      fetchCatch(response);
      // eslint-disable-next-line @typescript-eslint/no-throw-literal
      throw response;
    }
    return response.json();
  })
    .then((ownerOptionalAmounts: OwnerAddonOptionalAmounts[]) => {
      dispatch(setOwnerAddonsOptionalAmounts(ownerOptionalAmounts));
      return ownerOptionalAmounts;
    })
);

export default paymentAddonsReducer;
